import { createSelector } from "reselect";

import { RootState } from "@app/store/rootReducer";

const coachingNoteWithTaskState = (state: RootState) => state.scene.dashboard.coaching.noteWithTask;

export const getCoachingNoteWithTaskFailedTask = createSelector(
  coachingNoteWithTaskState,
  ({ failedTask }) => failedTask
);

export const isCoachingNoteWithTaskSubmitting = createSelector(
  coachingNoteWithTaskState,
  ({ submitting }) => submitting
);

export const isCoachingTaskRetrying = createSelector(
  coachingNoteWithTaskState,
  ({ retrying }) => retrying
);
